import {
  OptionComponent,
  RadioLayout,
  useSection,
} from "@tree-company/tree-query";
import clsx from "clsx";
import translate from "../locales";

export function StatementOpinionQuestion({
  question,
  className,
  handleChange,
}) {
  const {
    value,
    title,
    description,
    htmlAttributes,
    key,
    required,
    hint,
    errorMessages,
    valid,
    skip,
    options,
    disabled,
    ariaDisabled,
    layout,
  } = useSection(question);

  if (skip) {
    return null;
  }

  const optionType = layout === RadioLayout.buttons ? "button" : "radio";
  const labelId = `${key}Label`;

  return (
    <div
      role="group"
      aria-labelledby={labelId}
      aria-disabled={ariaDisabled}
      className={clsx(
        "question",
        "question--radio",
        htmlAttributes.class,
        { "question--required": required },
        { "question--invalid": !valid },
        { "question--disabled": disabled || ariaDisabled },
        className,
      )}
    >
      <span className="question__label" id={labelId}>
        {title}
        {description && (
          <span className="question__description">{description}</span>
        )}
      </span>

      <div
        className={clsx(
          "question__options",
          layout === RadioLayout.radios && "question__options--radios",
          layout === RadioLayout.buttons && "question__options--buttons",
        )}
      >
        {options.map((option) => (
          <OptionComponent
            key={option.value.toString()}
            baseKey={key}
            option={option}
            className="question__option"
            type={optionType}
            checked={value === option.value}
            onChange={(event) => {
              if (
                disabled ||
                ariaDisabled ||
                option.disabled ||
                option.ariaDisabled
              ) {
                return;
              }

              handleChange(event, option.value);
            }}
          />
        ))}
      </div>

      <div className="question__scale-indicators">
        <div className="question__scale-indicator">
          <span>{translate(["statementQuestion", "negative"])}</span>
        </div>
        <div className="question__scale-indicator">
          <span>{translate(["statementQuestion", "positive"])}</span>
        </div>
      </div>

      {hint && <span className="question__hint">{hint}</span>}
      {errorMessages.length > 0 && (
        <span className="question__error">{errorMessages[0]}</span>
      )}
    </div>
  );
}
